// extracted by mini-css-extract-plugin
module.exports = {"message":"global-message_message__2zH5b"};